import { makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles({
    linkButton: {
        border: "none",
        backgroundColor: "transparent",
        padding: 0,
        margin: 0,
        textDecoration: "underline",
        cursor: "pointer",
    },
});

const LinkButton = ({ children, className, ...props }) => {
    const styles = useStyles();
    return <button className={[styles.linkButton, className].join(" ")} {...props}>{children}</button>;
};

export default LinkButton;
